import React from 'react';

// Segmented Suppliers / Products switch, styled to match the Grid/List
// view-mode toggle so it reads as part of the same toolbar.
function SearchModeToggle({ mode, onChange }) {
  return (
    <div className="buttons search-mode-toggle mr-3">
      <button
        type="button"
        className={`button is-rounded ${mode === 'suppliers' ? 'is-primary' : ''}`}
        onClick={() => onChange('suppliers')}
      >
        <span className="icon">
          <i className="ph-bold ph-factory"></i>
        </span>
        <span>Suppliers</span>
      </button>
      <button
        type="button"
        className={`button is-rounded ${mode === 'products' ? 'is-primary' : ''}`}
        onClick={() => onChange('products')}
      >
        <span className="icon">
          <i className="ph-bold ph-package"></i>
        </span>
        <span>Products</span>
      </button>
    </div>
  );
}

export default SearchModeToggle;
